import { createContext, FC, useContext } from 'react';
import { useFragment, graphql } from 'react-relay';
import { useTranslationToggle, TranslationState } from 'dibs-elements/exports/useTranslationToggle';
import {
    PdpSharedOriginalLanguageProviderQuery,
    PdpSharedOriginalLanguageProviderQueryResponse,
} from './__generated__/PdpSharedOriginalLanguageProviderQuery.graphql';
import { PdpSharedOriginalLanguageProvider_item$key } from './__generated__/PdpSharedOriginalLanguageProvider_item.graphql';

export { INTERFACE_STATE } from 'dibs-elements/exports/useTranslationToggle';

type Props = {
    item: PdpSharedOriginalLanguageProvider_item$key;
};

export const OriginalLanguageContext = createContext<
    TranslationState<PdpSharedOriginalLanguageProviderQueryResponse>
>([null, null]);

export const PdpSharedOriginalLanguageProvider: FC<Props> = ({ children, item: itemRef }) => {
    const item = useFragment(
        graphql`
            fragment PdpSharedOriginalLanguageProvider_item on Item {
                serviceId
            }
        `,
        itemRef
    );
    const state = useTranslationToggle<PdpSharedOriginalLanguageProviderQuery>({
        query: graphql`
            query PdpSharedOriginalLanguageProviderQuery($itemId: String!) {
                viewer {
                    item(itemId: $itemId) {
                        title
                        description
                        pdpDetailsDisplay {
                            detailKey
                            detailValues {
                                detailKey
                                displayName
                                displayDetails
                            }
                        }
                    }
                }
            }
        `,
        variables: { itemId: item.serviceId || '' },
    });

    return (
        <OriginalLanguageContext.Provider value={state}>
            {children}
        </OriginalLanguageContext.Provider>
    );
};

export function useItemTranslations(): TranslationState<PdpSharedOriginalLanguageProviderQueryResponse> {
    return useContext(OriginalLanguageContext);
}
